export default __webpack_public_path__ + "static/media/hht2_ep15_timeline_q04_a.5fa55477.png";